export default __webpack_public_path__ + "static/media/mehmetbugra9.3429ef3f.jpg";